import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class ELearningService {
  constructor(private http: HttpClient, private api: AppConfig) {
  }

  getELearningById(id) {
    return this.http.get(this.api.baseUrl + '/eLearning/eLearning?id=' + id , this.api.jsonTokenHeaders);
  }

  getELearnings() {
    return this.http.get(this.api.baseUrl + '/eLearning/eLearnings', this.api.jsonTokenHeaders);
  }

  findByOrganization(orgId) {
    return this.http.get(this.api.baseUrl + '/eLearning/findByOrganization?organizationId=' + orgId, this.api.jsonTokenHeaders);
  }

  deleteELearnings(id) {
    return this.http.delete(this.api.baseUrl + '/eLearning/deleteELearning?id=' + id , this.api.jsonTokenHeaders);
  }

  addELearnings(data) {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ]) {
        formData.append(key , data[ key ]);
      }
    }
    return this.http.post(this.api.baseUrl + '/eLearning/addELearning' , formData , this.api.formDataHeaders);
  }

  getElearningForRecommendation(page = 1, perPage = 50, search) {
    return this.http.get(this.api.baseUrl + '/eLearning/eLearningForRecommendation?search=' + search + '&page=' +
      page + '&perPage=' + perPage, this.api.jsonTokenHeaders);
  }

  addRecommendation(data) {
    return this.http.post(this.api.baseUrl + '/recommendation/addRecommendation', data, this.api.jsonTokenHeaders);
  }

  removeRecommendation(id) {
    return this.http.get(this.api.baseUrl + '/recommendation/removeRecommendation?id=' + id, this.api.jsonTokenHeaders);
  }

  atobUtf8(str) {
    const binary = atob(str);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  }
}
